import React from 'react';
import { useCSS } from '../../lib/hooks.js';

const ItemTypeIndicator = (props) => {
	useCSS('comp/templates.css');

	const type = props?.type ?? false;

	if(!type || type.icon == undefined) return null;

	return (
		<div class="template_type" style={{background:type.color}}>
			<div class={"type_icon "+type.icon} />

			<p>{type.name}</p>
		</div>
	);
}

export default ItemTypeIndicator;